import React from 'react';
import { formatPurchaseMoney as money } from '../../utils/manualPurchase';

const OrderSummary = ({ item, quantity, pricing, validationMessage }) => (
  <section
    aria-label='Order Summary'
    className='purchase-card rounded-[10px] border border-[#e8ebef] bg-white px-[19px] py-[29px]'
  >
    <h2 className='text-2xl font-semibold text-gray-900'>Order Summary</h2>
    <div className='my-[30px]'>
      <h3 className='text-xl leading-8 font-semibold text-gray-900'>
        {item?.name || 'Select a ticket bundle'}
      </h3>
      <p className='mt-[3px] text-gray-500'>
        {item
          ? `${money(item.unitPrice)} x ${quantity || '—'}`
          : 'Price and quantity will appear here.'}
      </p>
    </div>
    <dl className='purchase-divider space-y-[15px] py-[30px] text-base'>
      <div className='flex justify-between gap-4'>
        <dt className='text-gray-500'>Subtotal</dt>
        <dd className='font-semibold'>
          {pricing ? money(pricing.subtotal) : '—'}
        </dd>
      </div>
      <div className='flex justify-between gap-4'>
        <dt className='text-gray-500'>
          Discount
          {pricing?.discountType === 'percentage'
            ? ` ${Number(pricing.discountValue)}%`
            : ''}
        </dt>
        <dd className='font-semibold'>
          {pricing ? `-${money(pricing.discountAmount)}` : '—'}
        </dd>
      </div>
    </dl>
    <div className='purchase-divider pt-[30px]'>
      <div className='flex justify-between gap-4 text-xl leading-8 font-semibold text-gray-900'>
        <span>Final total</span>
        <span>{pricing ? money(pricing.total) : '—'}</span>
      </div>
      <p className='mt-[3px] text-sm text-gray-500'>
        Final total is used for commission.
      </p>
      {!pricing && (
        <p className='mt-2 text-sm text-gray-500'>
          {validationMessage ||
            'Choose the item, quantity, and discount to calculate the total.'}
        </p>
      )}
    </div>
  </section>
);

export default OrderSummary;
